<template>
<!-- eslint-disable max-len -->
<span>
  <transition :enter-active-class="`animated ${narrative.type === 'enterLocation' ? 'fadeInLeft' : 'fadeInRight'}`">
    <div
      v-if="showTitle"
      class="title-box"
      :style="titleBoxStyle"
    >
      <img
        v-if="
          !useMediaZoneForNarrative
          && narrative.images && narrative.images.length && narrative.images[0].image
        "
        class="title-image"
        :style="titleImageStyle"
        :src="resolveAssetPath(narrative.images[0].image, 'images')"
      />
      <!--
        Never use v-html with end-user generated content, because it's a vector for XSS attacks
        This is what the following line used to be:
        <h1 class="title">{{ narrativeText }}</h1>
      -->
      <h1 class="title" :style="titleStyle" v-html="narrativeText"></h1>
    </div>
  </transition>

  <bottom-bar
    :next="this.showButton ? onComplete : undefined"
    :back="(enableBack ? (() => onComplete(true)) : undefined)"
  >
    <span slot="button">
      <span v-html="(narrative && narrative.nextButtonText) ? narrative.nextButtonText : ((game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next')"></span>
    </span>
    <span slot="back">
      <span v-html="(narrative && narrative.backButtonText) ? narrative.backButtonText : ((game && game.backButtonDefaultText) ? game.backButtonDefaultText : 'Back')"></span>
    </span>
  </bottom-bar>
</span>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

import BottomBar from '../ui/BottomBar';

export default {
  // $emit 'input' on complete
  components: {
    BottomBar
  },
  data() {
    return {
      showTitle: false,
      showButton: false
    };
  },
  computed: {
    ...mapGetters([
      'narrative',
      'tooltip',
      'game',
      'lastNarrative',
      'nextNarrative',
      'narrativeText',
      'starfighter',
      'native',
      'useMediaZoneForNarrative',
    ]),
    enableBack() {
      return this.showButton && (this.narrative.forceEnableBack || (this.game.enableBack && !(this.narrative.preventEnableBack)));
    },
    titleBoxStyle() {
      return {
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'justify-content': 'flex-start',
        top: (
          (!(this.useMediaZoneForNarrative)
          && this.narrative.images && this.narrative.images.length && this.narrative.images[0].image)
            ? '0'
            : undefined
        ),
      };
    },
    titleImageStyle() {
      return {
        'max-height': ((this.starfighter) ? '58vh' : undefined),
        'margin-bottom': ((this.starfighter) ? '15px' : undefined),
      };
    },
    titleStyle() {
      return {
        color: ((this.native && this.narrative.invertBackgroundlessTextColor) ? 'black' : undefined),
        'font-weight': ((this.native) ? 'bold' : undefined),
        'background-color': ((this.native) ? 'transparent' : undefined),
        'padding-top': ((this.native) ? '30px' : undefined),
      };
    }
  },
  methods: {
    ...mapActions([
      'stopSounds',
      'playSound',
      'playVoice',
    ]),
    async show() {
      await Vue.nextTick();
      this.stopSounds();
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.showTitle = true;
      if (this.narrative.textSound) {
        await Vue.nextTick();
        this.playSound({ sound: this.narrative.textSound });
      }
      if (this.narrative.textVoiceLine) {
        await Vue.nextTick();
        this.playVoice({ line: this.narrative.textVoiceLine });
      }
      await new Promise(resolve => setTimeout(resolve, 1250));
      this.showButton = true;
    },
    async hide() {
      this.showTitle = false;
      this.showButton = false;
      await Vue.nextTick();
      this.stopSounds();
    },
    async reset() {
      await this.hide();
      await Vue.nextTick();
      await this.show();
    },
    async onComplete(back = false) {
      if (this.tooltip && this.tooltip.preventStateProgressionWhileOpen) {
        window.dispatchEvent(new Event('click'));
        return;
      }
      await this.hide();
      this.$emit('input', back);
    }
  },
  watch: {
    async narrative(newValue) {
      if (newValue) await this.reset();
    }
  },
  async mounted() {
    await this.show();
  },
  async beforeDestroy() {
    await this.hide();
  }
};
</script>

<style lang="scss" scoped>
.fadeInLeft, .fadeInRight {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1); // out expo
}

.title-box {
  position: absolute;
  width: 100%;
  top: 180px;
}
.title-image {
  max-width: 55%;
  max-height: 64vh;
  object-fit: contain;
  border-radius: 7px;
  border: 2px solid white;
  box-shadow: 1px 2px 12px rgba(0, 0, 0, 0.45);
  margin-top: 30px;
}
.title {
  width: 100%;
  background-color: var(--primaryColor);
  font-size: 58px;
  color: white;
  padding: 60px 70px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/game/narrative/NarrativeLocation.vue